
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
	import SlzDialog from '@/components/dialog.vue';
  import previewImg from '@/components/previewImg.vue'
	import {
		// providerSelectItem,
		productInfo,
		createProduct,
		updateProduct,
		productUnitList,
		// productCategory,
		productList,
		// productproviderProductFirstTrialSuccess,
		// productproviderProductSendCheckSuccess,
		// productproviderProductFirstTrialFail,
		// productproviderProductSendCheckFail
	} from '@/api/supplier';
  @Component({  
    name: '',
    components: {
      PageFooter,
			SlzDialog,
			'slz-message': Message,
      previewImg
    }
  })

  export default class ProductList extends Vue {
    private formData:any = {}
    private supplierList:any = []
    private ProviderName = ''

		private refuseResultVal = 1
		private refuseDetail = ''
		private refuseResult = [
			{
				label: '商品信息不全',
				value: 1
			}, {
				label: '商品规格不正确',
				value: 2
			}, {
				label: '商品类型违规',
				value: 3
			}, {
				label: '其他',
				value: 4
			}
		]
    private showCheckBox = false
    private showPassConfirm = false
    private previewShow = false
    private currentUrl = ''


    private mounted () {
      // this.getSupplierList()
      if(this.$route.query.id){
        this.getinfo()
      }
    }
    
    private preview(e){
      this.currentUrl = e
      this.previewShow = true
    }
		private async confirm() {
			if (!this.refuseDetail) {
				this.$message('请输入驳回理由')
				return;
			}
			this.showCheckBox = false;

			// this.doCheck(2);
		}
		// private async doCheck(state: number) {
		// 	try {
		// 		let res:any
		// 		let data:any = {
		// 			ProductId:this.formData.Id
		// 		}
		// 		if (state === 1){
		// 			if(this.formData.ProductCheckState==0){
		// 				res = await productproviderProductFirstTrialSuccess(data)
		// 			}else if(this.formData.ProductCheckState==4){
		// 				res = await productproviderProductSendCheckSuccess(data)
		// 			}

		// 		}else{
		// 			data.ProductRejectType = this.refuseResultVal
		// 			data.ProductRejectReason = this.refuseDetail
		// 			if(this.formData.ProductCheckState==0){
		// 				res = await productproviderProductFirstTrialFail(data)
		// 			}else if(this.formData.ProductCheckState==4){
		// 				res = await productproviderProductSendCheckFail(data)
		// 			}
		// 		}
		// 		if(res.IsSuccess){
		// 			this.cancel()
		// 			this.$message({
		// 				type: 'success',
		// 				message: '操作成功'
		// 			})
		// 			this.toBack();
		// 		}
		// 	} catch (e) {
		// 		console.log(e)
		// 	}
		// }
    private cancel() {
			this.showCheckBox = false;
			this.refuseResultVal = 1
			this.refuseDetail = ''
		}
    private toBack(){
      this.$router.go(-1)
    }
		private handlePassConfirm() {
			// this.doCheck(1);
		}
    private async getinfo(){
      try{
        const res: any = await productInfo({
          Id: this.$route.query.id
        })
        if(res.IsSuccess){
          this.formData = res.Result
        }
        // const res2: any = await providerSelectItem({});
        // this.supplierList = res2.Result
        // this.ProviderName = this.supplierList.find(v=>v.Id==this.formData.ProviderId).ProviderName||''
        // console.log(this.formData.ProviderName)
      }finally{
        //
      }
    }
    
		// 获取供应商列表
		// private async getSupplierList() {
		// 	// this.loadingSupplier = true;
		// 	try {
		// 		const res: any = await providerSelectItem({});
		// 		this.supplierList = res.Result
		// 		// this.loadingSupplier = false;
		// 	} catch (e) {
		// 		// this.loadingSupplier = false;
		// 		// console.log('supplierList ===>', e);
		// 	}
		// }
  }
